import { Icon, type IconName } from './Icon.tsx';
import { cx } from './util.ts';
import './StatusBadge.css';

/** Estados de docs/design.md §4.3: cada uno con su forma de icono y su palabra. */
export type Status = 'ok' | 'escalado' | 'error' | 'pendiente' | 'auto' | 'sospechoso';

export const STATUS_META: Record<Status, { label: string; icon: IconName }> = {
  ok: { label: 'Correcto', icon: 'estado-ok' },
  escalado: { label: 'Revisa una persona', icon: 'estado-escalado' },
  error: { label: 'Error', icon: 'estado-error' },
  pendiente: { label: 'Pendiente', icon: 'estado-pendiente' },
  auto: { label: 'Aprobado por regla', icon: 'estado-auto' },
  sospechoso: { label: 'Sospechoso', icon: 'estado-sospechoso' },
};

export const STATUSES = Object.keys(STATUS_META) as Status[];

export interface StatusBadgeProps {
  status: Status;
  /** Sustituye la palabra por defecto (p. ej. «No cuadra» para un error de cálculo). */
  label?: string;
  /** soft: fondo suave (tablas); solid: color pleno (para destacar). */
  variant?: 'soft' | 'solid';
  className?: string;
}

export function StatusBadge({ status, label, variant = 'soft', className }: StatusBadgeProps) {
  const meta = STATUS_META[status];
  return (
    <span
      className={cx('af-status', `af-status--${status}`, `af-status--${variant}`, className)}
      data-status={status}
    >
      <Icon name={meta.icon} size="1.1em" />
      <span>{label ?? meta.label}</span>
    </span>
  );
}
